import React, { useState } from 'react';
import { Container } from "react-bootstrap";
import classes from '../pages.module.css';
import TextCol from "../../components/Ui/text/textCol";
import BtnDownload from '../../components/Ui/button/btnDownload';
import agregator from '../../image/modules/aggregator.jpeg';
import ModuleItem from '../../components/Ui/block/moduleItem';

const MicroOTN = () => {
    const [texts, settexts] = useState([
        {id:1, content: 'Конвергенция всего трафика через OTN, включая низкоскоростные сервисы'},
        {id:2, content: 'Не имитация SDH, а настоящий E1oOTN'},
        {id:3, content: 'Полная совместимость с существующим оборудованием'},
        {id:4, content: 'Клиентский SLA остаётся без изменений (TDM остаётся TDM)'},
        {id:5, content: 'Полный вывод из эксплуатации любого оборудования SDH / PDH'},
        {id:6, content: 'Не влияет на CPE или SLA клиента'},
        {id:7, content: 'Предоставление сервиса не прерывается'},
        {id:8, content: 'Полная инфраструктура OTN / WDM с огромным увеличением емкости, минимальной задержкой и сохранением синхронизации'},
    ])
    const [lists, setlists] = useState ([
        {id:1, list: 'Интерфейсы: 2x63xE1 (75 Ом или 120 Ом) + NxSTM-n / OTU1'},
        {id:2, list: 'Переключение: E1 / VC12 / ODUε12, ODU0 гранулярность'},
        {id:3, list: 'Стекируется c другими агрегаторами или хабами'},
        {id:4, list: 'Управляется как одиночный сетевой элемент в стеке с другими полками'},
        {id:5, list: 'Питание: -48 В'},
        {id:6, list: 'Синхронизация IF: 2 МГц / 2 Мбит'},
        {id:7, list: 'Защита матрицы и контроллера EPS'},
        {id:8, list: 'Защита питания: EPS'},
        {id:9, list: 'Агрегация E1 через OTN'},
        {id:10, list: 'Резервирование сети: VC12 / VC4 SNCP ODUεe / 0/1 / SNC'},
        {id:11, list: 'Синхронизация SDH, 2 МГц, 2 Мбит / с'},
        {id:12, list: 'Perfomance monitoring: OTN, SDH'},
        {id:13, list: 'Протокол управления: RESTCONF / Yang'}
    ])
    const [lists1, setlists1] = useState([
        {id:1, list:'Интерфейсы: Dual OTU2 + NxSTM / 1/4/16 / OTU1 + NxSTM1 / 4/16/64'},
        {id:2, list:'Возможности коммутации: VC12 / ODUε12, VC4 / ODUε4, с гранулярностью ODU0'},
        {id:3, list:'Управление несколькими полками LM-1 1 OTN, LM-1 micro ROADM как единым сетевым элементом'},
        {id:4, list:'Питание: -48 В'},
        {id:5, list:'Синхронизация: 2 МГц / 2 Мбит, 1PPS / TOD'},
        {id:6, list:'Резервирование матрицы и контроллера: EPS'},
        {id:7, list:'Резервирование питания: EPS'},
        {id:8, list:'Сервисы: агрегация E1 через OTN и функция хаба в направлении SDH'},
        {id:9, list:'Сетевое соединение: ODUεe / 0/1 unidir / bidir / D&C защита'},
        {id:10, list:'Резервирование трафика: ODUεe / 0/1 / SNC'},
        {id:11, list:'Синхронизация SDH'},
        {id:12, list:'Perfomance monitoring: OTN, SDH'},
        {id:13, list:'Протокол управления: RESTCONF / Yang в соответствии с моделью ONF'},
    ])

    return(
        <>
            <div className={classes.topBox}>
                <Container fluid="md">
                    <div className={classes.topboxBody}>
                        <span>оборудование для оптических сетей</span>
                        <h1>Micro OTN</h1>
                        <p>Полноценное решение для миграции с существующих сетей SDH/PDH на современные сети OTN/WDM. Micro OTN агрегатор выполняет преобразование сервисов E1 в линейные интерфейсы OTN (линейные интерфейсы OTU1). При этом MICRO OTN HUB имеет возможность организовывать кольца SDH и/или OTN агрегаторов E1 и обрабатывать трафик с различными интерфейсами как SDH STM-1/4/16 или новыми OTU1/OTU2. Это позволяет обеспечить плавную миграцию существующих сетей в современные сети OTN/WDM, просто, без влияния на трафик во время миграции на новые, более скоростные сервисы.</p>
                    </div>
                </Container>
                <div className={classes.topBg_small}></div>
            </div>
            <TextCol texts={texts} />
            <BtnDownload title="Скачать спецификацию" url='/src/download/test.txt' />
            <ModuleItem item={{
                class: 'moduleItem1',
                title: 'LM-1 Micro OTN Aggregator',
                src: (agregator),

            }}
                lists={lists}
            />
            <ModuleItem item={{
                class: 'moduleItem2',
                title: 'LM-1Micro OTN HUB',
                src: (agregator),

            }}
                lists={lists1}
            />
        </>
    )
}

export default MicroOTN;